module.exports = __webpack_public_path__ + "img/srt-icon.6b6c0dc8.svg";